import { render } from "./TheProfile.vue?vue&type=template&id=dbed3a6e&scoped=true"
import script from "./TheProfile.vue?vue&type=script&lang=js"
export * from "./TheProfile.vue?vue&type=script&lang=js"

import "./TheProfile.vue?vue&type=style&index=0&id=dbed3a6e&scoped=true&lang=css"

import exportComponent from "E:\\GIT\\WEB\\catch-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbed3a6e"]])

export default __exports__